/**
 * Reçu d'un encaissement du registre unique (consultation, services,
 * hospitalisation, pharmacie) ou d'un remboursement.
 * Les montants viennent du serveur (ligne du registre des paiements).
 */
import { blocInfos, dateFr, e, fcfa } from '@/impression/impression'

const NATURES = {
  CONSULTATION: 'Consultation',
  FACTURE_SERVICE: 'Examens et services',
  HOSPITALISATION: 'Hospitalisation',
  VENTE: 'Pharmacie',
  REMBOURSEMENT: 'Remboursement',
}

/**
 * @param {object} p ligne du registre (GET /paiements)
 * @param {'ticket'|'A5'} format
 */
export function documentRecu(p, format = 'ticket') {
  const remboursement = p.type === 'REMBOURSEMENT'
  const annule = p.statut && p.statut !== 'VALIDE'
  const corps = `
    ${blocInfos([
      ['Patient', p.patient ? e(p.patient.nom) : '—'],
      p.patient?.numeroDossier ? ['Dossier', e(p.patient.numeroDossier)] : null,
      p.patient?.responsable ? ['Responsable', e(p.patient.responsable)] : null,
      ['Objet', `${e(NATURES[p.acte?.type] || NATURES[p.type] || p.type)}${p.acte?.numero ? ' · ' + e(p.acte.numero) : ''}`],
      remboursement && p.origine ? ['Rembourse le reçu', e(p.origine.numero)] : null,
    ].filter(Boolean), 1)}
    ${p.partAssurance > 0 ? `
      <div class="section">Prise en charge</div>
      ${blocInfos([
        ['Assurance', `${e(p.assurance || '—')}${p.taux ? ` (${p.taux} %)` : ''}`],
        p.numeroAssure ? ['N° assuré', e(p.numeroAssure)] : null,
        ['Montant de l’acte', fcfa(p.montant)],
        ['Part assurance', fcfa(p.partAssurance)],
      ].filter(Boolean), 1)}` : ''}
    <table class="totaux">
      <tr class="grand"><td>${remboursement ? 'Montant rendu au patient' : 'Montant payé par le patient'}</td><td class="droite">${fcfa(Math.abs(p.partPatient))}</td></tr>
      ${p.montantDonne && !remboursement ? `<tr><td>Somme remise</td><td class="droite">${fcfa(p.montantDonne)}</td></tr><tr><td>Monnaie rendue</td><td class="droite">${fcfa(Math.max(0, p.montantDonne - p.partPatient))}</td></tr>` : ''}
      <tr><td>Mode</td><td class="droite">${e(p.moyen || '—')}</td></tr>
    </table>
    ${annule ? `<div class="encadre centre"><span class="badge-ko">${p.statut === 'REMBOURSE' ? 'REMBOURSÉ' : 'ANNULÉ'} le ${e(dateFr(p.annuleLe, true))}</span><br><small>${e(p.motifAnnulation || '')}</small></div>` : ''}
    <div class="centre" style="margin-top:8px">${p.caissier ? `Caissier : <strong>${e(p.caissier)}</strong><br>` : ''}Merci pour votre confiance</div>`

  return {
    titre: remboursement ? 'Reçu de remboursement' : 'Reçu de paiement',
    numero: p.numero,
    date: dateFr(p.date, true),
    corps,
    format,
  }
}

export default { documentRecu }
